import { defineStore } from 'pinia'
import { resolveLocale } from '@/utils/locale'

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    language: 'de' as string,
    country: null as string | null,
  }),
  getters: {
    locale: (state): string => resolveLocale(state.language, state.country),
  },
  actions: {
    setCountry(value: string | null) {
      this.country = value
    },
    setLanguage(value: string) {
      this.language = value
    },
  },
})
